module.exports = __webpack_public_path__ + "img/dns.cf6f4bf.webp";